import { AddressForm, FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useTranslation } from 'react-i18next';

const LabelTaxAddressStep = () => {
  const { t } = useTranslation();
  return (
    <LabelFormStep
      header={t('label.form.tax-office.header')}
      description={t('label.form.tax-office.description')}>
      <AddressForm
        topContent={
          <FormInput.Text
            name={`taxOffice.name`}
            label={t('input.label.name')}
            wrapperClassName='max-w-full'
          />
        }
        propertyPrefix='taxOffice.'
        noMaxWidth
        noHeader
      />
    </LabelFormStep>
  );
};

export default LabelTaxAddressStep;
